import styled from "styled-components";
import {styledByTheme} from "../../../themes/architecture/styled-by-theme";

const MobileMenuItemLinkDefaultBox = styled.a`
  display: flex;
  align-items: center;
  flex-grow: 1;
  padding: 1.5rem 0;
  ${({theme}) => theme.font.presets.regular};
  font-size: 1.6rem;
  font-weight: 300;
  line-height: 1;
  color: ${props => props.theme.colors.textLight};
  background-color: ${props => props.theme.colors.background};
  border-bottom: 1px solid ${props => props.theme.colors.boxBorderDark};
`

const MobileMenuItemLinkCasino777Box = styled(MobileMenuItemLinkDefaultBox)`
    color: ${props => props.theme.colors.text};
    ${({theme}) => theme.font.presets.bold};
    border: none;
`

const MobileMenuItemLinkCasinoMrGreenBox = styled(MobileMenuItemLinkDefaultBox)`
    background-color: transparent;
    border: none;
`

export const MobileMenuItemLinkBox = styledByTheme(MobileMenuItemLinkDefaultBox)
    .forCasino777(MobileMenuItemLinkCasino777Box)
    .forMrGreen(MobileMenuItemLinkCasinoMrGreenBox)
    .apply();
